<template>
  <div class="merchant-users">
    <v-row no-gutters>
      <v-col cols="12" md="12" class="pa-0">
        <div class="card card-custom card-compact ">
          <div class="card-header card-header-nobdr ">
            <div class="card-title">
              <h3 class="card-label">Admin Users</h3>
              <span class="sub-title">Showing all admin users</span>
            </div>
            <div class="header-aside-content">
              <div class="aside-btn">
                <v-btn
                  color="primary"
                  @click="createUser"
                  height="38"
                  width="100"
                >
                  Create <v-icon right dark> mdi-account-plus </v-icon></v-btn
                >
              </div>
            </div>
          </div>
          <div class="card-body pt-5">

              <v-data-table
          :headers="userHeader"
          :items="userList"
          disable-pagination
          :loading="userLoading"
          :hide-default-footer="true"
          
        >
          <template v-slot:[`item.actions`]="{ item }">
          
            <v-icon  @click="editUser(item)" color="red">
              mdi-account-edit
            </v-icon>
          </template>
          <template v-slot:[`item.status`]="{ item }">
              <!-- <span class="status-btn" :class="item.status">{{ item.status }}</span> -->
            <span class="status-info">
                <v-switch
                v-model="item.status"
                color="info"
                dense
                :value="item.status"
                @change="updateStatus(item)"
                hide-details
                ></v-switch>
            </span>
           </template>
          <template v-slot:[`item.createdDate`]="{ item }">
              {{item.createdDate | defaultDate}}
           </template>
        </v-data-table>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="addUser" width="600" persistent>
        <create-user @close="closePopup" @postNewUser="creatNewUser" ref="createUser" :loading="createLoading" />
    </v-dialog>
    <v-dialog v-model="editDialog"  width="600" persistent>
        <update-user :userData="userData" @closeEditDialog="closeEditDialog" @updateUserProfile="editUserInfo" :loading="updateLoading" />        
    </v-dialog>
    <v-dialog
      v-model="statusConfirmDialog"
      persistent
      max-width="350"
    >
        <div class="confirmation-box">
            <div class="confirm-dialog">
                <h6>Are You Sure You Want To Update Status?</h6>
            </div>
            <div class="form-popup-footer">
                    <v-btn color="grey darken-1" text @click="cancelUpdateStatus">
                    Cancel
                    </v-btn>
                    <v-btn
                    color="primary"
                    text
                    @click="confirmUpdateStatus"
                    
                    >
                    Continue
                    </v-btn>
                </div>
        </div>
    </v-dialog>
  </div>
</template>
<script>
import Promise from "../../../../lib/mixins/ExtendedPromises";
import Admin from "../../../../repositories/adminUserController";
import CreateUser from './components/CreateUser.vue';
import UpdateUser from './components/UpdateUser.vue';

export default {
    mixins: [Promise],
  components: { CreateUser, UpdateUser },
  name: "MerchantUser",
  data () {
      return {
          userLoading: false,
          userData: {},
          editDialog: false,
          currentItem: {},
          statusConfirmDialog: false,
          switchValue: false,
          addUser: false,
          userHeader: [
                {
                    text: "fullName",
                    align: "start",
                    sortable: false,
                    value: "fullName",
                    width: '130'
                },
                { text: "Merchant Name", value: "merchantName", sortable: false, width: '160'  },
                { text: "User Name", value: "username", sortable: false, width: '150' },
                { text: "Mobile", value: "mobileNumber", sortable: false, width: '150'  },
                { text: "status", value: "status", sortable: false, width: '130'  },
                { text: "Created", value: "createdDate", sortable: false,  width: '130' },
                { text: "Actions", value: "actions", sortable: false }
          ],
          userList: [],
          createLoading: false,
          updateLoading: false,
      }
  },
  mounted () {
      this.getUserList()
  },
  methods: {
    confirmUpdateStatus () {
        this.statusConfirmDialog = false;
        let status = ''
        if(this.currentItem.status === true) {
            status = 'ACTIVE';
        } else {
            status = 'INACTIVE';
        }
     
        const operation = this.response(Admin.updateUserStatus(this.currentItem.userId, status));
        operation
        .then(response => {
          if (operation.isFulfilled()) {
               this.$toasted.show(
                  response.data.message
                );
          }
        })
        .catch(err => {
          if(this.currentItem.status){
            this.currentItem.status = false;
            } else {
                this.currentItem.status = true;
            }
        });
    },
    cancelUpdateStatus () {
        if(this.currentItem.status){
            this.currentItem.status = false;
        } else {
            this.currentItem.status = true;
        }
        this.statusConfirmDialog = false;
    },
    updateStatus (item) {
        this.currentItem = item;
        this.statusConfirmDialog = true;

        
    },
    createUser() {
     
        this.addUser = true;
    },
    closePopup () {

        this.addUser = false;
    },
    getUserList () {
      this.userLoading = true;
         const operation = this.response(Admin.getAllAdminUsers());
        operation
        .then(response => {
          if (operation.isFulfilled()) {
              this.userList = response.data;
              this.userList.forEach(item => {
                  if(item.status === 'ACTIVE') {
                      item.status = true;
                  } else {
                      item.status = false;
                  }
              })
              this.userLoading = false;
          }
        })
        .catch(err => {
          this.userLoading = false;
        });
    },
    creatNewUser (item) {

        this.createLoading = true;
        item.userType = 'ADMIN_USER';
        const operation = this.response(Admin.createUser(item));
        operation
        .then(response => {
          if (operation.isFulfilled()) {
              this.$refs.createUser.resetForm();
              this.addUser = false;
              this.createLoading = false;
              this.getUserList();
              this.$toasted.show(
                  "User Created Successfully"
                );
              
          }
        })
        .catch(err => {
          this.$toasted.show(`${err.data.message}`,{
                    type:'error'
                  })
          this.createLoading = false;
        });
    },
    editUser (item) {
        this.userData.fullName = item.fullName;
        this.userData.mobileNumber = item.mobileNumber;
        this.userData.username = item.username;
        this.currentItem = item;
        this.editDialog = true;
    },
    closeEditDialog() {
        this.editDialog = false;
    },
    editUserInfo (item) {
        this.updateLoading = true;
        item.userType = 'ADMIN_USER';
        const operation = this.response(Admin.updateUser(this.currentItem.userId,item));
        operation
        .then(response => {
          if (operation.isFulfilled()) {
              this.editDialog = false;
              this.updateLoading = false;
              this.$toasted.show(
                  "User Updated Successfully"
                );
              this.getUserList();
          }
        })
        .catch(err => {
          this.updateLoading = false;
        });
    }
  }
};
</script>
